import { render, staticRenderFns } from "./FieldBlock.vue?vue&type=template&id=71de83ac"
import script from "./FieldBlock.vue?vue&type=script&lang=js"
export * from "./FieldBlock.vue?vue&type=script&lang=js"
import style0 from "./FieldBlock.vue?vue&type=style&index=0&id=71de83ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports